module.exports = __webpack_public_path__ + "img/02.339ddf77.png";